import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorConditionGTM } from "../../../Utils/googleTags";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";

type nonPaySuspendDetailsInitialStateType = {
  nonPaySuspendPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: nonPaySuspendDetailsInitialStateType = {
  nonPaySuspendPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = 'non-pay-suspend.json'

export const getNonPaySuspendPageContent = createAsyncThunk(
  "get/nonPaySuspend-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const nonPaySuspendDetailSlice = createSlice({
  name: "nonPaySuspend-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNonPaySuspendPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNonPaySuspendPageContent.fulfilled, (state, action) => {
      state.nonPaySuspendPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getNonPaySuspendPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Vacation pause service AEM Content",
        action.error?.message,
        action?.type
      );
      state.nonPaySuspendPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default nonPaySuspendDetailSlice.reducer;
